import React from "react";
import heroBanner from "../Assets/SliderImg.jpeg";

const BannerSlider = () => {
  return (
    <section className="w-full overflow-hidden 
                        mt-16 sm:mt-20 md:mt-24 lg:mt-44 
                        h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[80vh] xl:h-screen">
      
      <img
        src={heroBanner}
        alt="Hero Banner"
        className="w-full h-full object-cover object-center"
      />

    </section>
  );
};

export default BannerSlider;